// Bento Section Coming Soon Functionality
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("bentoComingSoonModal");
  const modalCloseBtn = modal?.querySelector(".bento-modal-close");
  const disabledCards = document.querySelectorAll(".bento-disabled");
  const newsletterForm = document.getElementById("bentoNewsletterForm");
  const emailInput = document.getElementById("bentoEmail");
  const submitBtn = newsletterForm?.querySelector(".bento-submit-btn");
  const btnText = submitBtn?.querySelector(".bento-btn-text");
  const btnLoading = submitBtn?.querySelector(".bento-btn-loading");
  const successMessage = modal?.querySelector(".bento-form-success");
  const errorMessage = modal?.querySelector(".bento-form-error");

  // Show modal with smooth animation
  function showModal() {
    if (modal) {
      modal.classList.add("show");
      document.body.style.overflow = "hidden";

      // Check if form was successfully submitted
      checkFormSuccess();

      // Focus on email input after animation
      setTimeout(() => {
        if (successMessage && successMessage.style.display === "none") {
          emailInput?.focus();
        }
      }, 300);
    }
  }

  // Hide modal with smooth animation
  function hideModal() {
    if (modal) {
      modal.classList.remove("show");
      document.body.style.overflow = "";

      // Reset form state
      setTimeout(() => {
        resetFormState();
      }, 300);
    }
  }

  // Reset form to initial state
  function resetFormState() {
    if (newsletterForm) {
      newsletterForm.reset();
    }
    if (submitBtn) {
      submitBtn.disabled = false;
    }
    if (btnText) {
      btnText.style.display = "";
    }
    if (btnLoading) {
      btnLoading.style.display = "none";
    }
    if (successMessage) {
      successMessage.style.display = "none";
    }
    if (errorMessage) {
      errorMessage.style.display = "none";
    }
  }

  // Show loading state
  function showLoadingState() {
    if (submitBtn) {
      submitBtn.disabled = true;
    }
    if (btnText) {
      btnText.style.display = "none";
    }
    if (btnLoading) {
      btnLoading.style.display = "flex";
    }
  }

  // Show success state
  function showSuccessState() {
    if (submitBtn) {
      submitBtn.disabled = false;
    }
    if (btnText) {
      btnText.style.display = "";
    }
    if (btnLoading) {
      btnLoading.style.display = "none";
    }
    if (successMessage) {
      successMessage.style.display = "block";
    }
    if (errorMessage) {
      errorMessage.style.display = "none";
    }
  }

  // Show error state
  function showErrorState() {
    if (submitBtn) {
      submitBtn.disabled = false;
    }
    if (btnText) {
      btnText.style.display = "";
    }
    if (btnLoading) {
      btnLoading.style.display = "none";
    }
    if (errorMessage) {
      errorMessage.style.display = "block";
    }
    if (successMessage) {
      successMessage.style.display = "none";
    }
  }

  // Check if form was submitted successfully and auto-close modal
  function checkFormSuccess() {
    if (successMessage && successMessage.style.display !== "none") {
      // Auto close modal after 3 seconds on successful submission
      setTimeout(() => {
        hideModal();
      }, 3000);
    }
  }

  // Event listeners for disabled cards
  disabledCards.forEach((card) => {
    card.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Add click animation
      card.style.transform = "scale(0.98)";
      setTimeout(() => {
        card.style.transform = "";
      }, 150);

      showModal();
    });

    // Add keyboard support
    card.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        showModal();
      }
    });

    // Make focusable for accessibility
    card.setAttribute("tabindex", "0");
    card.setAttribute("role", "button");
    card.setAttribute(
      "aria-label",
      "Coming soon - Click to subscribe for updates"
    );
  });

  // Close modal events
  modalCloseBtn?.addEventListener("click", hideModal);

  // Close modal when clicking backdrop
  modal?.addEventListener("click", function (e) {
    if (e.target === modal) {
      hideModal();
    }
  });

  // Close modal with Escape key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal?.classList.contains("show")) {
      hideModal();
    }
  });

  // Handle form submission - just show loading state, Shopify handles the rest
  newsletterForm?.addEventListener("submit", function (e) {
    const email = emailInput?.value?.trim();
    if (!email) {
      e.preventDefault();
      emailInput?.focus();
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      e.preventDefault();
      showErrorState();
      if (errorMessage && errorMessage.querySelector("p")) {
        errorMessage.querySelector("p").textContent =
          "Please enter a valid email address.";
      }
      return;
    }

    // Show loading state while form submits
    showLoadingState();
  });

  // Add smooth scroll and intersection observer for better UX
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.animationPlayState = "running";
      }
    });
  });

  // Observe all bento cards for animation
  document.querySelectorAll(".bento-category-card").forEach((card) => {
    observer.observe(card);
  });

  // Initialize - check if modal should be shown (form errors or success)
  function initializeModal() {
    if (modal) {
      const hasFormErrors = errorMessage && !errorMessage.hasAttribute("style");
      const hasFormSuccess =
        successMessage && !successMessage.hasAttribute("style");

      if (hasFormErrors || hasFormSuccess) {
        showModal();
        if (hasFormSuccess) {
          checkFormSuccess();
        }
      }
    }
  }

  // Call initialization
  initializeModal();
});
